import React, { createContext, useContext, useState } from 'react'

const BlogCacheContext = createContext()

export function BlogCacheProvider({ children }) {
  const [blogCache, setBlogCache] = useState({ posts: {} })

  return <BlogCacheContext.Provider value={{ blogCache, setBlogCache }}>{children}</BlogCacheContext.Provider>
}

export function useBlogCache() {
  return useContext(BlogCacheContext)
}
